<template>
  <div id="ni-app">
    <NewItemAppHeader />
    <li
      v-show="showUserHeaderInfo"
      class="column is-offset-6 is-3 is-right ni-user-header-info-wrapper"
    >
      <span class="ni-temp-user-name">{{ getUserName() }}</span>
      <span class="ni-temp-divider">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
      <a class="ni-temp-logout" @click="logout">Logout</a>
    </li>
    <router-view />
    <NewItemAppFooter />
  </div>
</template>
<script>
// import EventBus from "./event-bus/.js";
import NewItemAppHeader from "./components/NewItemAppHeader.vue";
import NewItemAppFooter from "./components/NewItemAppFooter.vue";
export default {
  components: { NewItemAppHeader, NewItemAppFooter },
  data() {
    return {
      showUserHeaderInfo: false
    };
  },
  mounted() {
    if (!window.$cookies.isKey("ni_key")) {
      if (window.location.search) {
        this.manageSupplierFormView();
      } else {
        this.logout();
      }
    } else {
      this.$routeTo.push({ path: "/homePage" });
    }
  },
  updated() {
    if (this.$routeTo.app._route.path !== "/") {
      this.showUserHeaderInfo = true;
    } else {
      this.showUserHeaderInfo = false;
    }
  },
  methods: {
    manageSupplierFormView() {
      if (
        window.location.pathname === "/createNewSubmission" ||
        window.location.pathname === "/createNewEUSubmission"
      ) {
        this.showCreateForm();
      } else if (
        window.location.pathname === "/editSubmission" ||
        window.location.pathname === "/editEuSubmission"
      ) {
        this.showEditForm();
      }
    },
    showCreateForm() {
      sessionStorage.removeItem("se_ni_user");
      sessionStorage.removeItem("createRequestFromSe", true);
      window.$cookies.remove("createSubmission");
      var jwtKey = window.location.search.split("?")[1];
      var base64Url = jwtKey.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var userData = JSON.parse(window.atob(base64));
      if (userData) {
        var niKeyObj = {
          nameUser: userData.user.firstName + " " + userData.user.lastName,
          networkId: userData.user.userId,
          roleKey: 1,
          userType: userData.user.userType,
          userEmail: userData.user.email,
          supplierId: userData.user.supplierId,
          vnList: userData.supplier.supplierAliases,
          supplierName: userData.supplier.supplierName
        };
        //route to region specific Create Submission Form
        if (window.location.pathname === "/createNewSubmission") {
          sessionStorage.setItem("se_ni_user", JSON.stringify(niKeyObj));
          sessionStorage.setItem("createRequestFromSe", true);
          this.$routeTo.push({ path: "/createNewSubmission" });
        } else if (window.location.pathname === "/createNewEUSubmission") {
          sessionStorage.setItem("se_ni_user_eu", JSON.stringify(niKeyObj));
          sessionStorage.setItem("createRequestEUFromSe", true);
          this.$routeTo.push({ path: "/createNewEUSubmission" });
        }
      } else {
        this.sessionInactive();
      }
    },
    showEditForm() {
      sessionStorage.removeItem("se_ni_user");
      sessionStorage.removeItem("editRequestFromSe", true);
      window.$cookies.remove("submissionObj");
      var keys = window.location.search.split("?");
      var jwtKeyForEdit = keys[1].split("&")[1];
      var submissionDetail = keys[1].split("&")[0];
      var submissionId = submissionDetail.split(",")[0];
      var status = submissionDetail.split(",")[1];
      var base64UrlEdit = jwtKeyForEdit.split(".")[1];
      console.log("error base 1" + base64UrlEdit);
      var base64Edit = base64UrlEdit.replace(/-/g, "+").replace(/_/g, "/");
      if (base64Edit) {
        console.log("jwt s");
      } else {
        console.log("undefined s" + base64UrlEdit);
      }
      var userDataForEdit = JSON.parse(window.atob(base64Edit));
      if (userDataForEdit) {
        var niKeyEditObj = {
          nameUser:
            userDataForEdit.user.firstName +
            " " +
            userDataForEdit.user.lastName,
          networkId: userDataForEdit.user.userId,
          roleKey: 1,
          userType: userDataForEdit.user.userType,
          userEmail: userDataForEdit.user.email,
          supplierId: userDataForEdit.supplier.supplierId,
          vnList: userDataForEdit.supplier.supplierAliases,
          supplierName: userDataForEdit.supplier.supplierName
        };
        if (window.location.pathname === "/editSubmission") {
          sessionStorage.setItem("se_ni_user", JSON.stringify(niKeyEditObj));
          if (status === "Draft") {
            sessionStorage.setItem("editRequestFromSe", submissionId);
          } else {
            sessionStorage.setItem("viewRequestFromSe", submissionId);
          }
          this.$routeTo.push({ path: "/editSubmission" });
        } else if (window.location.pathname === "/editEuSubmission") {
          sessionStorage.setItem("se_ni_user_eu", JSON.stringify(niKeyEditObj));
          if (status === "Draft" || status === "Rework") {
            sessionStorage.setItem("editRequestFromSeEu", submissionId);
            if (status === "Rework") {
              sessionStorage.setItem("reworkItem", true);
            } else {
              sessionStorage.removeItem("reworkItem");
            }
          } else if (status === "Review") {
            sessionStorage.setItem("reViewRequestFromSeEu", submissionId);
            sessionStorage.removeItem("reworkItem");
          } else {
            sessionStorage.setItem("viewRequestFromSeEu", submissionId);
            sessionStorage.removeItem("reworkItem");
          }
        }
      } else {
        this.sessionInactive();
      }
    },
    sessionInactive() {
      this.$buefy.dialog.confirm({
        message: "Session inactive, please login to Supplier Exchange.",
        confirmText: "OK",
        type: "is-success",
        onConfirm: () => window.close()
      });
    },
    getUserName() {
      if (window.$cookies.isKey("ni_key")) {
        return window.$cookies.get("ni_key").nameUser;
      } else if (sessionStorage.getItem("se_ni_user")) {
        return JSON.parse(sessionStorage.getItem("se_ni_user")).nameUser;
      } else if (sessionStorage.getItem("se_ni_user_eu")) {
        return JSON.parse(sessionStorage.getItem("se_ni_user_eu")).nameUser;
      }
    },
    logout() {
      window.$cookies.remove("createRequestFromSe");
      window.$cookies.remove("createRequestEUFromSe");
      if (sessionStorage.getItem("se_ni_user")) {
        sessionStorage.removeItem("se_ni_user");
        window.close();
      }
      if (sessionStorage.getItem("se_ni_user_eu")) {
        sessionStorage.removeItem("se_ni_user_eu");
        window.close();
      } else {
        window.$cookies.remove("ni_key");
        this.$router.push({ path: "/" });
      }
    }
  }
};
</script>
<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
  
</style>
